module.exports = __webpack_public_path__ + "img/pantalla-2-3.fea3dc28.png";